import { render, staticRenderFns } from "./HandBackLeft.vue?vue&type=template&id=4b8a3f07"
import script from "./HandBackLeft.vue?vue&type=script&lang=js"
export * from "./HandBackLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports